export default __webpack_public_path__ + "static/media/studio-bag.0f3196ed.png";